export const APP_VERSION = process.env.VUE_APP_VERSION_NAME || "";
export const isSG = APP_VERSION.startsWith("SG");
